// extracted by mini-css-extract-plugin
export default {"roomContainer":"ReelRoom_roomContainer__U8rrx","incomingMails":"ReelRoom_incomingMails__mx3Wf"};